import React from "react";

class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredData: []
        }
    }

    componentDidUpdate(prevProps) {
        // console.log(prevProps.value, this.props.value);
        if ((prevProps.value !== this.props.value)) this.filteredData();
    }

    filteredData = () => {
        const { value, data, subCollection, vendorSelector, collection, collection2, trip } = this.props;
        const filteredData = data.filter(doc => {
            // console.log(doc)

            // if (this.props.field == "email") {
            //     console.log(doc.email)
            //     return doc.email
            // }
            if (!doc.name && doc.firstName && doc.lastName) {
                doc.name = `${doc.firstName} ${doc.lastName}`;
            } else if (!doc.name) {
                return false;
            };
            
            if (vendorSelector && doc.name) {
                if (doc.airCodes && (doc.vendorType === "Forward Air" || doc.vendorType === "All-Cargo Airline" || doc.vendorType === "LTL Carrier")) {
                    doc.name = (doc.name.includes(doc.airCodes[0])) ? doc.name : `${doc.name} - ${doc.physicalCity}, ${doc.airCodes[0]}`;
                }

                if (doc.vendorType === "Passenger Airline") return false;
            }

            if (subCollection && doc.name) {
                doc.name = doc.firstName ? `${doc['firstName']} ${doc['lastName']}` : doc.name;
            } else {
                doc.name = doc.firstName ? `${doc['firstName']} ${doc['lastName']}` : doc.name;
            }

            if ((collection.includes('vendors') || (collection2 && collection2.includes('vendors'))) && !vendorSelector && !trip && doc.airCodes && doc.airCodes.length) {
                doc.name = (doc.name.includes(doc.airCodes[0])) ? doc.name : `${doc.name} ${doc.airCodes[0]}`;
            }

            return this.props.field == "email" ? doc.email.toLowerCase().includes(value && value.toLowerCase()) : doc.name.toUpperCase().includes(value && value.toUpperCase());
        });
        // data && data.map(doc => {
        //     if (vendorSelector && doc.name) {
        //         if (doc.vendorType == "Passenger Airline") {
        //             const airCode = doc.airCodes ? `${doc.airCodes[0]}` : '';
        //             doc.name = (doc.name.includes(airCode)) ? doc.name : `${doc.name} ${airCode}`;
        //         } else {
        //             doc.name = doc.name
        //         }
        //     }

        //     if (subCollection && doc.name) {
        //         doc.name = doc.firstName ? `${doc['firstName']} ${doc['lastName']}` : doc.name;
        //         if (doc.name.toUpperCase().includes(value && value.toUpperCase())) filteredData.push(doc);
        //     } else {
        //         doc.name = doc.firstName ? `${doc['firstName']} ${doc['lastName']}` : doc.name;
        //         if (doc.name.toUpperCase().includes(value && value.toUpperCase())) filteredData.push(doc);
        //     }
        // });

        const check = {}
        filteredData.filter(u => check[u.name] ? false : check[u.name] = u)

        this.setState({ filteredData: filteredData });
    }

    render() {

        // console.log(this.state);
        // console.log(this.props);
        return this.props.value.length > 0 ? this.state.filteredData.map((doc, i) => (
            <div
                onClick={() => {
                    this.props.assignUser(doc, this.props.stateObj, this.props.id)
                    this.setState({ filteredData: [] });
                    this.props.clear();
                }}
                key={i}
            >
                <h5 key={i} style={{ color: "black", fontSize: ".9rem" }}><b>{this.props.field == "email" ? doc.email : doc.name}</b></h5>

            </div>
        )) : null;
    }

}

export default Users;


// WEBPACK FOOTER //
// ./src/views/Explore/PrototypeExploreMapAssignUser.jsx